//@flow
import { Formik } from 'formik';
import _ from 'lodash';
import * as React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import connect from 'react-redux/es/connect/connect';
import * as Yup from 'yup';
import Toast from '../../components/Toasts/Toast';
import { isSudo } from '../../helpers/permissions.helper';
import { defaultService } from '../../services/defaultService';
import { pontoAtendimentoService } from '../../services/pontoAtendimento.service';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import { clienteService } from '../../services/cliente.service';
import FormSelectInput from '../../components/Inputs/FormSelectInput';
import { userService } from '../../services/user.service';
import { confirmAlert } from 'react-confirm-alert';
import InputMask from 'react-input-mask';
import FormInput from '../../components/Inputs/FormInput';
import { objectsConstants } from '../../constants/objects.constants';
import SelectInput from '../../components/Inputs/SelectInput';
const getValidationSchema = ({ isSudo }) =>
  Yup.object().shape({
    cliente: Yup.mixed()
      .nullable()
      .when([], {
        is: () => isSudo,
        then: Yup.object().required('Cliente é obrigatório'),
        otherwise: Yup.mixed().notRequired(),
      }),
    email: Yup.string()
      .nullable()
      .email('E-mail inválido'),
    telefone: Yup.string()
      .nullable()
      .test('telefone-valido', 'Telefone inválido', (value) => {
        if (!value) return true;
        return /^\(\d{2}\) (?:\d{4,5})-\d{4}$/.test(value);
      }),
    nome: Yup.string()
      .nullable()
      .required('Nome é obrigatório'),
    usuarioPadrao: Yup.string()
      .nullable()
      .required('Usuário padrão é obrigatório'),
    senhaPadrao: Yup.string()
      .nullable()
      .required('Senha é obrigatório'),
    endereco: Yup.object()
      .nullable()
      .shape({
        logradouro: Yup.string()
          .nullable()
          .required('Logradouro é obrigatório'),
        numero: Yup.string()
          .nullable()
          .required('Número é obrigatório'),
        bairro: Yup.string()
          .nullable()
          .required('Bairro é obrigatório'),
        cidade: Yup.string()
          .nullable()
          .required('Cidade é obrigatória'),
        uf: Yup.string()
          .nullable()
          .required('UF é obrigatório'),
        cep: Yup.string()
          .nullable()
          .matches(/\d{5}-?\d{3}/, 'CEP inválido')
          .required('CEP é obrigatório'),
      }),
  });

class PontoAtendimentoEdit extends React.PureComponent<Props> {
  constructor(props) {
    super(props);
    const user = userService.getCurrentUser();
    this.state = {
      entity: {
        endereco: {},
        cliente: isSudo() ? null : user.cliente,
        senhaPadrao: '',
      },
    };
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      pontoAtendimentoService.doGet(this.props.match.params.id).then(
        async (response) => {
          const pontoAtendimento = response.data;

          if (isSudo() && pontoAtendimento.codigoCliente) {
            try {
              const clienteResponse = await clienteService.findByCodigoCliente(
                pontoAtendimento.codigoCliente
              );
              pontoAtendimento.cliente = clienteResponse.data;
            } catch (e) {
              console.error('Erro ao buscar cliente completo', e);
            }
          }
          pontoAtendimento.senhaPadrao = null;
          this.setState({ entity: pontoAtendimento });
        },
        (error) => {
          console.error(error);
          this.props.loading(false);
        }
      );
    }
  }

  render() {
    const { entity } = this.state;
    const isEdit = !!this.state.entity.id;
    console.log(entity);

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle="Ponto de Atendimento"
          subTitle=" "
          canBack={true}
        />
        <Formik
          validationSchema={(values) =>
            getValidationSchema({ isSudo: isSudo() })
          }
          context={{ isSudo: isSudo() }}
          validateOnBlur={false}
          validateOnChange={false}
          initialValues={entity}
          enableReinitialize={true}
          onSubmit={(values, actions) => {
            const entidade = _.cloneDeep(values);

            if (_.get(entidade, '_links.self.href')) {
              _.set(
                entidade,
                'id',
                defaultService.getIdFromUrl(_.get(entidade, '_links.self.href'))
              );
            }

            if (!isSudo()) {
              entidade.cliente = userService.getCurrentUser().cliente;
            }
            if (!entidade.senhaPadrao || entidade.senhaPadrao.trim() === '') {
              delete entidade.senhaPadrao;
            }
            console.log(entidade);

            pontoAtendimentoService
              .doSave(entidade)
              .then((response) => {
                console.log(response);
                const id = response.data.id;
                values.id = id;
                this.props.history.push('/pontoAtendimento');
                actions.setSubmitting(false);
                this.props.success({
                  message: 'Ponto de Atendimento salvo com sucesso.',
                });
              })
              .catch((e) => {
                console.error(e);
                actions.setSubmitting(false);
              });
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => {
            console.log(errors); // <-- Aqui fora do return, funciona!
            return (
              <form onSubmit={handleSubmit} noValidate>
                <div className="flex-column">
                  <Toast />

                  <div className="cardSeculus d-flex flex-column mb-0">
                    <div className="topoCard d-flex flex-column flex-sm-row">
                      <h3 className="flex-grow-1">
                        Informações do Ponto de Atendimento
                      </h3>
                    </div>

                    <div className="form-row">
                      {isSudo() && (
                        <div className="form-group col-6">
                          <FormSelectInput
                            name={`cliente`}
                            id={'cliente'}
                            label="Cliente"
                            placeholder="Selecione o cliente"
                            valueKey="codigoCliente"
                            labelKey="label"
                            noSize={true}
                            required={true}
                            returnFullObject={true}
                            isMulti={false}
                            searchable={false}
                            allowSelectAll={false}
                            service={clienteService.findAll}
                            onChange={(name, value) => {
                              console.log(name, value);

                              setFieldValue(name, value);
                            }}
                            value={values.cliente}
                            erroMensagem={
                              _.get(touched, 'cliente') &&
                              _.get(errors, 'cliente')
                            }
                          />
                        </div>
                      )}

                      <div className="form-group col-12 col-lg-6">
                        <FormInput
                          label="Nome"
                          noSize
                          id="nome"
                          type="text"
                          erroMensagem={errors.nome}
                          name="nome"
                          value={values.nome}
                          onChange={setFieldValue}
                          required
                        />
                      </div>
                      <div className="form-group col-12 col-md-6">
                        <FormInput
                          label="Regional"
                          noSize
                          id="regional"
                          type="text"
                          name="regional"
                          value={values.regional}
                          onChange={setFieldValue}
                        />
                      </div>
                      <div className="form-group col-12 col-md-6">
                        <label>Telefone</label>
                        <InputMask
                          mask={
                            values.telefone &&
                            values.telefone.replace(/\D/g, '').length > 10
                              ? '(99) 99999-9999'
                              : '(99) 9999-9999'
                          }
                          value={values.telefone}
                          onChange={handleChange}
                          name="telefone"
                          className={`form-control ${
                            errors.telefone ? 'error' : ''
                          }`}
                        >
                          {(inputProps) => (
                            <input {...inputProps} type="text" />
                          )}
                        </InputMask>
                      </div>
                      <div className="form-group col-12 col-md-6 ">
                        <FormInput
                          label="E-mail"
                          noSize
                          id="email"
                          type="text"
                          erroMensagem={errors.email}
                          name="email"
                          placeholder="Digite o e-mail"
                          value={values.email}
                          onChange={setFieldValue}
                          autoComplete="new-email"
                        />
                      </div>

                      <div className="form-group col-12 col-lg-12">
                        <FormInput
                          label="Descrição"
                          noSize
                          id="descricao"
                          type="text"
                          name="descricao"
                          value={values.descricao}
                          onChange={setFieldValue}
                        />
                      </div>

                      <div className="form-group col-12 col-lg-6">
                        <FormInput
                          label=" Usuário Padrão"
                          noSize
                          id="usuarioPadrao"
                          type="text"
                          erroMensagem={errors.usuarioPadrao}
                          name="usuarioPadrao"
                          value={values.usuarioPadrao}
                          onChange={setFieldValue}
                          required
                        />
                      </div>

                      <div className="form-group col-12 col-lg-6">
                        <FormInput
                          label="Senha Padrão"
                          noSize
                          id="senhaPadrao"
                          type="password"
                          erroMensagem={errors.senhaPadrao}
                          name="senhaPadrao"
                          value={values.senhaPadrao}
                          onChange={setFieldValue}
                          autoComplete="new-password"
                          required
                        />
                      </div>

                      <div className="form-group col-12">
                        <h4>Endereço</h4>
                      </div>

                      {[
                        'logradouro',
                        'numero',
                        'complemento',
                        'bairro',
                        'cidade',
                        'uf',
                        'cep',
                      ].map((field) => {
                        const isObrigatorio = field !== 'complemento';
                        return (
                          <div
                            className="form-group col-12 col-lg-6"
                            key={field}
                          >
                            {field === 'uf' ? (
                              <SelectInput
                                id={`endereco.${field}`}
                                label="UF"
                                noSize
                                required={isObrigatorio}
                                returnFullObject={true}
                                labelKey="label"
                                valueKey="value"
                                name={`endereco.${field}`}
                                options={objectsConstants.UF}
                                value={
                                  _.isObject(_.get(values, `endereco.${field}`))
                                    ? _.get(values, `endereco.${field}`)
                                    : {
                                        label: _.get(
                                          values,
                                          `endereco.${field}`,
                                          ''
                                        ),
                                        value: _.get(
                                          values,
                                          `endereco.${field}`,
                                          ''
                                        ),
                                      }
                                }
                                erroMensagem={_.get(
                                  errors,
                                  `endereco.${field}`
                                )}
                                onChange={(name, value) => {
                                  setFieldValue(name, value ? value.value : '');
                                }}
                              />
                            ) : (
                              <FormInput
                                label={_.startCase(field)}
                                noSize
                                id={`endereco${field}`}
                                type="text"
                                required={isObrigatorio}
                                erroMensagem={_.get(
                                  errors,
                                  `endereco.${field}`
                                )}
                                name={`endereco.${field}`}
                                value={_.get(values, `endereco.${field}`, '')}
                                onChange={setFieldValue}
                              />
                            )}
                          </div>
                        );
                      })}
                    </div>

                    <div className="d-flex flex-row flex-sm-row ">
                      <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                        <button
                          type="button"
                          className="btn btn-secondary btn30 white"
                          disabled={isSubmitting}
                          onClick={() => this.props.history.goBack()}
                        >
                          Cancelar
                        </button>
                      </div>
                      {isEdit && (
                        <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                          <button
                            type="button"
                            className="btn btn-danger btn30"
                            disabled={isSubmitting}
                            onClick={() => {
                              confirmAlert({
                                customUI: ({ onClose }) => (
                                  <div className="custom-confirm-alert">
                                    <h2>Confirmar exclusão</h2>
                                    <p>
                                      Você tem certeza que deseja excluir este
                                      Ponto de Atendimento?
                                    </p>
                                    <div className="d-flex justify-content-around mt-4">
                                      <button
                                        className="btn btn-secondary btn30 white"
                                        onClick={onClose}
                                      >
                                        Não
                                      </button>
                                      <button
                                        className="btn btn-danger btn30"
                                        onClick={async () => {
                                          try {
                                            await pontoAtendimentoService.doDelete(
                                              values.id
                                            );
                                            this.props.success({
                                              message:
                                                'Ponto de Atendimento excluído com sucesso.',
                                            });
                                            this.props.history.push(
                                              '/pontoAtendimento'
                                            );
                                            onClose();
                                          } catch (e) {
                                            console.error(e);
                                            this.props.error({
                                              message:
                                                'Erro ao excluir o Ponto de Atendimento.',
                                            });
                                            onClose();
                                          }
                                        }}
                                      >
                                        Sim
                                      </button>
                                    </div>
                                  </div>
                                ),
                              });
                            }}
                          >
                            Excluir
                          </button>
                        </div>
                      )}

                      <div className="col-6 col-lg text-center p-0 mt-lg-2 mb-1">
                        <button
                          type="submit"
                          className="btn btn-secondary btn30 green"
                          disabled={isSubmitting}
                        >
                          {isEdit ? 'Salvar Alterações' : 'Salvar'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return { user };
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(
  mapStateToProps,
  mapDispatch,
  null,
  { forwardRef: true }
)(PontoAtendimentoEdit);
